import ParticipantsTable from 'features/participants/components/Table';
import { useParticipantsTable } from 'features/participants/hooks';

export const ParticipantsContent = ({ participants }) => {
  const tableProps = useParticipantsTable(participants);

  return <ParticipantsTable tableProps={tableProps} />;
};
